// extracted by mini-css-extract-plugin
export default {"mobile":"650px","tablet":"1000px","medium":"800px"};